import { createStore } from 'vuex'

export default createStore({
  state: {
    services: [
      {
        id: 'laser-cutting',
        title: 'Лазерный раскрой листа',
        description: 'Режем листы толщиной до 40 мм.',
        icon: 'cut',
        background: '/img/laser_cutting.png',
        features: [
          'Высокая точность реза',
          'Минимальная зона термического влияния',
          'Высокая скорость обработки',
          'Возможность резки сложных форм'
        ]
      },
      {
        id: 'tube-cutting',
        title: 'Гибка заготовок из листа',
        description: 'Гнем заготовки из листа с высокой точностью.',
        background: '/img/gibka.png',
        icon: 'hammer',
        features: [
          'Отсутствие деформаций при гибке',
          'Высокая скорость обработки',
          'Минимальная зона термического влияния',
          'Высокое качество'
        ]
      },
      {
        id: 'metal-bending',
        title: 'Прокат заготовок на вальцах',
        description: 'Прокатим заготовки на вальцах с высокой точностью.',
        background: '/img/v_prokat.png',
        icon: 'gavel',
        features: [
          'Высокоточная гибка по чертежам',
          'Работа с различными металлами',
          'Гибка по радиусу и под любым углом',
          'Максимальная длина заготовки до 3000 мм'
        ]
      },
      {
        id: 'guillotine',
        title: 'Сварка: дуговая, лазерная, полуавтоматическая, роботизированная',
        description: 'Свариваем все виды стали, изготавливаем металлоконструкции любой сложности.',
        icon: 'bolt',
        background: '/img/svarka.png',
        features: [
          'Высокая точность реза',
          'Высокая производительность',
          'Ровный срез без заусенцев',
          'Экономичность при раскрое листов'
        ]
      },
      {
        id: 'stamping',
        title: 'Лазерная обработка труб',
        description: 'Резка трубы/профиля 6000 мм х 200 мм',
        background: '/img/laser_tr.png',
        icon: 'bolt-lightning',
        features: [
          'Высокая производительность',
          'Точное соблюдение размеров',
          'Изготовление деталей сложной формы',
          'Возможность серийного производства'
        ]
      },
      {
        id: 'welding',
        title: 'Гибка труб на полуавтоматическом станке',
        description: 'Гибка трубы до диаметра 80, круга до 70 мм в зависимости от радиуса гиба',
        icon: 'plug-circle-bolt',
        background: '/img/auto_st.png',
        features: [
          'Электродуговая сварка',
          'Полуавтоматическая сварка',
          'Лазерная сварка',
          'Качественные сварные швы'
        ]
      },
      {
        id: 'shot-blasting',
        title: 'Покрасочные камеры',
        description: 'Покрасочные камеры порошково- полимерного покрытия до 120 мкн.\nРазмер загрузки до 1800х1600x3000.\nВключает предварительную подготовку поверхности дробеметом и обезжириванием.',
        icon: 'paint-roller',
        background: '/img/color.png',
        features: [
          'Очистка поверхности от коррозии и окалины',
          'Создание идеальной поверхности',
          'Повышение адгезии покрытия',
          'Увеличение срока службы покрытия'
        ]
      },
      {
        id: 'galvanizing',
        title: 'Антикоррозионное гальваническое покрытие цинком',
        description: 'В настоящее время спроектирована и находится в производстве установка термодиффузионного нанесения цинка от 60 до 200 мкн',
        icon: 'fill-drip',
        background: '/img/zink.png',
        features: [
          'Защита от коррозии',
          'Увеличение срока службы изделий',
          'Высокое качество покрытия',
          'Различные варианты цинкования'
        ]
      },
      {
        id: 'powder-coating',
        title: 'Холодно-штамповочное производство',
        description: '',
        icon: 'stamp',
        background: '/img/stamp.png',
        features: [
          'Широкая цветовая гамма',
          'Устойчивость к механическим повреждениям',
          'Экологически чистое покрытие',
          'Долгий срок службы'
        ]
      }
    ],
    equipment: [
      {
        id: 'laser-cutting-equipment',
        title: 'Оборудование для лазерной резки',
        items: [
          {
            name: 'BODOR F3015-1000W',
            description: 'Высокоточный станок для резки листового металла (серия F).',
            specs: [
              { name: 'Рабочая область', value: '1500 × 3000 мм' },
              { name: 'Мощность', value: '1000 Вт' },
              { name: 'Материалы', value: 'Углеродистая сталь, нержавейка, алюминий' },
              { name: 'Точность позиционирования', value: '±0.03 мм' },
              { name: 'Повторяемость', value: '±0.02 мм' },
              { name: 'Макс. скорость', value: '140 м/мин' },
              { name: 'Тип лазера', value: 'Волоконный' },
              { name: 'Производитель', value: 'Bodor' }
            ],
            capabilities: [
              'Высокая точность реза',
              'Минимальная зона термического влияния',
              'Чистый рез тонких листов',
              'Стабильная работа на серийном производстве'
            ],
            features: [
              'Автофокус лазерной головки',
              'Сварная термостабилизированная станина',
              'Интерфейс ЧПУ с библиотекой параметров'
            ],
            applications: [
              'Корпусные детали',
              'Декоративные элементы',
              'Тонколистовые изделия'
            ],
            media: [
              '/img/equipment/bodor_1.webp',
              '/img/equipment/bodor_2.jpg',
              '/img/new_equipment/bodor/bodor_1.jpeg',
              '/img/new_equipment/bodor/bodor_2.jpg',
              '/img/new_equipment/bodor/bodor_3.jpg'
            ],
            videos: [
              { type: 'youtube', url: 'https://www.youtube.com/embed/VlmeofyJQl4?si=PBadyddLKhN0kjjz', title: 'Работа станка BODOR F3015' }
            ]
          },
          {
            name: 'BODOR F3015-3000W',
            description: 'Промышленный лазерный станок повышенной мощности для толстых листов.',
            specs: [
              { name: 'Рабочая область', value: '1500 × 3000 мм' },
              { name: 'Мощность', value: '3000 Вт' },
              { name: 'Макс. толщина реза (сталь)', value: 'До 20 мм' },
              { name: 'Материалы', value: 'Углеродистая сталь, нержавейка, алюминий' },
              { name: 'Точность позиционирования', value: '±0.03 мм' },
              { name: 'Повторяемость', value: '±0.02 мм' },
              { name: 'Макс. скорость', value: '140 м/мин' },
              { name: 'Тип лазера', value: 'Волоконный' },
              { name: 'Производитель', value: 'Bodor' }
            ],
            capabilities: [
              'Высокая скорость обработки',
              'Резка более толстых листов',
              'Стабильность и повторяемость'
            ],
            features: [
              'Автофокус',
              'Оптимизация траектории',
              'Интегрированные системы безопасности'
            ],
            applications: [
              'Несущие элементы',
              'Площадки и кронштейны',
              'Серийная резка листов 10–20 мм'
            ],
            media: [
              '/img/new_equipment/bodor/bodor_1.jpeg',
              '/img/new_equipment/bodor/bodor_2.jpg',
              '/img/new_equipment/bodor/bodor_3.jpg'
            ]
          },
          {
            name: 'SF6015G (3000 Raycus)',
            description: 'Листовой лазер с увеличенной рабочей зоной по длине.',
            specs: [
              { name: 'Рабочая длина', value: '6000 мм' },
              { name: 'Рабочая ширина', value: '1500 мм' },
              { name: 'Мощность', value: '3000 Вт' },
              { name: 'Источник лазера', value: 'Raycus' },
              { name: 'Материалы', value: 'Черная сталь, нержавейка, алюминий' },
              { name: 'Тип лазера', value: 'Волоконный' }
            ],
            capabilities: [
              'Обработка крупногабаритных заготовок',
              'Работа с длинномерными листами'
            ],
            features: [
              'Усиленная станина для длинной платформы',
              'Система дымоудаления по всей длине стола',
              'Привод с ЧПУ'
            ],
            applications: [
              'Фасадные панели',
              'Длинномерные элементы каркасов',
              'Крупные кожухи'
            ],
            media: [
              '/img/new_equipment/raycus_SF6015G/raycus_1.jpg',
              '/img/new_equipment/raycus_SF6015G/raycus_2.jpg'
            ]
          },
          {
            name: 'LX20120LD-12kW',
            description: 'Сверхмощный волоконный лазер для высокопроизводительной резки крупноформатных листов.',
            specs: [
              { name: 'Рабочая область', value: '2000 × 12000 мм' },
              { name: 'Мощность', value: '12 кВт' },
              { name: 'Макс. толщина реза (сталь)', value: 'До 40 мм' },
              { name: 'Материалы', value: 'Углеродистая сталь, нержавейка, алюминий' },
              { name: 'Тип лазера', value: 'Волоконный' }
            ],
            capabilities: [
              'Резка сверхтолстых листов',
              'Максимальная производительность на крупном формате',
              'Высокая стабильность при длительной работе'
            ],
            features: [
              'Массивная портальная конструкция',
              'Усиленная кинематика для длинного стола',
              'Опциональные автоматические загрузка/выгрузка'
            ],
            applications: [
              'Толстолистовые детали 20–40 мм',
              'Крупные панели и заготовки',
              'Тяжелое машиностроение'
            ],
            media: [
              '/img/new_equipment/LX20120LD-12kW/LX20120LD-12kW .jpeg',
              '/img/new_equipment/LX20120LD-12kW/IMG_20230605_113440.jpg',
              '/img/new_equipment/LX20120LD-12kW/IMG_20230605_095439.jpg'
            ]
          }
        ]
      },
      {
        id: 'tube-cutting-equipment',
        title: 'Оборудование для резки труб',
        items: [
          {
            name: 'ALTESA LX62TN - 3000W Raycus',
            description: 'Специализированный станок для лазерной резки труб и профилей.',
            specs: [
              { name: 'Макс. длина трубы', value: '6000 мм' },
              { name: 'Диапазон диаметров', value: '20-220 мм' },
              { name: 'Мощность', value: '3000 Вт' },
              { name: 'Источник лазера', value: 'Raycus' },
              { name: 'Точность позиционирования', value: '±0.03 мм/1000 мм' },
              { name: 'Макс. нагрузка патрона', value: '200 кг' },
              { name: 'Габариты станка', value: '12000 × 2700 × 2400 мм' },
              { name: 'Поддерживаемые профили', value: 'Круг, квадрат, прямоугольник, овал, T, U, H, L' }
            ],
            capabilities: [
              'Резка стандартных и сложных профилей',
              'Высокая точность позиционирования',
              'Поддержка длинномерных труб (6 м)'
            ],
            features: [
              'Автоматические самоцентрирующиеся патроны',
              'Система податчика/приемника',
              'ЧПУ-управление контуром и фасками'
            ],
            applications: [
              'Рамы и каркасы',
              'Трубные конструкции',
              'Силовые и архитектурные профили'
            ],
            media: [
              '/img/new_equipment/ALTESA_LX62TN/ALTESA LX62TN - 3000W Raycus-2.jpeg',
              '/img/new_equipment/ALTESA_LX62TN/IMG_20231019_104115-2.jpg'
            ],
            videos: [
              { type: 'local', url: '/img/new_equipment/ALTESA_LX62TN/2026-01-26 13.16.34.mp4', title: 'ALTESA LX62TN в работе' },
              { type: 'local', url: '/img/new_equipment/ALTESA_LX62TN/2026-01-26 13.16.38.mp4', title: 'ALTESA LX62TN резка трубы' },
              { type: 'local', url: '/img/new_equipment/ALTESA_LX62TN/VID_20250321_163348.mp4', title: 'ALTESA LX62TN демонстрация' },
              { type: 'local', url: '/img/new_equipment/ALTESA_LX62TN/VID_20250321_16341334.mp4', title: 'ALTESA LX62TN процесс резки' }
            ]
          }
        ]
      },
      {
        id: 'welding-equipment',
        title: 'Сварочное оборудование',
        items: [
          {
            name: 'QJR6-1400H (промышленный сварочный робот)',
            description: '6-осевой робот для автоматизации MIG/MAG сварки.',
            specs: [
              { name: 'Количество осей', value: '6' },
              { name: 'Грузоподъемность', value: '6 кг' },
              { name: 'Радиус действия', value: '1456 мм' },
              { name: 'Повторяемость', value: '±0.08 мм' },
              { name: 'Вес робота', value: '150 кг' },
              { name: 'Типы сварки', value: 'MIG, MAG' },
              { name: 'Управление', value: 'Программируемое ЧПУ/роботконтроллер' }
            ],
            capabilities: [
              'Прецизионная сварка',
              'Высокая повторяемость швов',
              'Интеграция в роботизированные ячейки'
            ],
            features: [
              'Поддержка позиционеров и датчиков шва',
              'Гибкая офлайн-программирование',
              'Стабильная дуга при серийной сварке'
            ],
            applications: [
              'Сварка серийных узлов',
              'Производство металлоконструкций',
              'Автомотив и машиностроение'
            ],
            media: [
              '/img/new_equipment/QJR6-1400H/IMG_1323.jpg',
              '/img/new_equipment/QJR6-1400H/IMG_1325.jpg'
            ],
            videos: [
            ]
          },
          {
            name: '3 поста п/а сварки проволокой',
            description: 'Три полуавтоматических сварочных поста для MIG/MAG с подачей проволоки.',
            specs: [
              { name: 'Процесс', value: 'Полуавтоматическая дуговая сварка (MIG/MAG)' },
              { name: 'Материалы', value: 'Сталь, нержавейка, алюминий' },
              { name: 'Количество постов', value: '3' }
            ],
            capabilities: [
              'Качественные сварные швы',
              'Разные режимы сварки под материалы/толщины',
              'Параллельная работа на трёх постах'
            ],
            features: [
              'Стабильная подача проволоки',
              'Регулировка тока/напряжения',
              'Поддержка защитных газов'
            ],
            applications: [
              'Мелко- и среднесерийная сборка',
              'Ремонтные и производственные участки'
            ],
            media: [
              '/img/new_equipment/3_posta_svarki_provolokoi/3 поста п-а сварки проволокой.jpeg',
              '/img/new_equipment/3_posta_svarki_provolokoi/3 поста п-а сварки проволокой 1.jpeg'
            ]
          },
          {
            name: 'Лазерная сварка LXCW-3000',
            description: 'Лазерный сварочный комплекс 3 кВт для высокоточной сварки, включая разнородные металлы.',
            specs: [
              { name: 'Мощность', value: '3000 Вт' },
              { name: 'Материалы', value: 'Золото, серебро, титан, никель, олово, медь, алюминий, сплавы' },
              { name: 'Процесс', value: 'Лазерная сварка' },
              { name: 'Зона термовлияния', value: 'Минимальная' }
            ],
            capabilities: [
              'Высокая точность сварки',
              'Сварка разнородных металлов',
              'Минимальная деформация'
            ],
            features: [
              'Точная фокусировка луча',
              'Регулировка параметров импульса/мощности',
              'Поддержка присадочной проволоки (опционально)'
            ],
            applications: [
              'Тонкостенные изделия',
              'Ювелирка и точные компоненты',
              'Герметичные швы'
            ],
            media: [
              '/img/new_equipment/LXCW-3000/IMG_20230502_111034-2-2.jpg'
            ]
          }
        ]
      },
      {
        id: 'guillotine-equipment',
        title: 'Гильотинное оборудование',
        items: [
          {
            name: 'Гидравлические гильотинные ножницы серии SB-K',
            description: 'Мощные гидравлические ножницы для резки листового металла.',
            specs: [
              { name: 'Макс. ширина реза', value: '4000 мм' },
              { name: 'Макс. толщина реза', value: '40 мм' },
              { name: 'Тип привода', value: 'Гидравлический' },
              { name: 'Материалы', value: 'Сталь, алюминий, медь, латунь, титан, композиты' }
            ],
            capabilities: [
              'Высокая точность реза',
              'Идеально ровный срез',
              'Стабильность на толстых листах'
            ],
            features: [
              'Регулировка зазора ножей',
              'Прижимы листа по кромке',
              'Системы безопасности'
            ],
            applications: [
              'Заготовительные операции',
              'Рубка листов под гибку/резку',
              'Подготовка к мехобработке'
            ],
            media: [
              '/img/new_equipment/SB-K_iron_cut/IMG_1333.jpg',
              '/img/new_equipment/SB-K_iron_cut/IMG_1334.jpg'
            ]
          }
        ]
      },
      {
        id: 'bending-equipment',
        title: 'Оборудование для гибки металла',
        items: [
          {
            name: 'Ermaksan Speed Bend 2600-100',
            description: 'Гидравлический листогиб для точной гибки металлических листов.',
            specs: [
              { name: 'Макс. ширина гибки', value: '2500 мм' },
              { name: 'Усилие пресса', value: '100 тонн' },
              { name: 'Тип', value: 'Гидравлический' },
              { name: 'Управление', value: 'CNC/NC (зависит от комплектации)' }
            ],
            capabilities: [
              'Гибка по радиусу',
              'Гибка под любым углом',
              'Стабильная повторяемость'
            ],
            features: [
              'Задний упор с ЧПУ',
              'Линейные направляющие',
              'Система безопасности по световым завесам'
            ],
            applications: [
              'Корпусные детали',
              'Профили и короба',
              'Серийная гибка тонко- и среднелистовых изделий'
            ],
            media: [
              '/img/new_equipment/ermaksan/IMG_20230605_092853-2-2.jpg'
            ],
            videos: [
              { type: 'local', url: '/img/new_equipment/ermaksan/VID_20250321_161426.mp4', title: 'Ermaksan Speed Bend в работе' }
            ]
          },
          {
            name: 'MVD iBend B220x3100',
            description: 'Современный ЧПУ листогиб с усилием 220 т и шириной 3100 мм.',
            specs: [
              { name: 'Макс. ширина гибки', value: '3100 мм' },
              { name: 'Усилие пресса', value: '220 тонн' },
              { name: 'Управление', value: 'CNC' },
              { name: 'Задний упор', value: 'Многокоординатный (по опции)' }
            ],
            capabilities: [
              'Гибка сложных деталей',
              'Высокая повторяемость',
              'Поддержка программирования последовательностей'
            ],
            features: [
              'Прецизионные линейки и датчики',
              'Энергоэффективная гидравлика',
              'Опции быстрого переналадки инструмента'
            ],
            applications: [
              'Крупные панели/профили',
              'Серийная гибка',
              'Тяжёлые заготовки'
            ],
            media: [
              '/img/new_equipment/mvd_ibend/MVD iBend B220x3100 -2.jpeg',
              '/img/new_equipment/mvd_ibend/IMG_20230605_092919-2.jpg'
            ]
          },
          {
            name: 'ПЛГ-160.32 (листогиб гидравлический)',
            description: 'Надёжный гидравлический листогиб с увеличенным усилием.',
            specs: [
              { name: 'Макс. ширина гибки', value: '3200 мм' },
              { name: 'Усилие пресса', value: '160 тонн' },
              { name: 'Тип', value: 'Гидравлический' }
            ],
            capabilities: [
              'Работа с толстыми листами',
              'Высокая производительность',
              'Стабильная точность угла'
            ],
            features: [
              'Прочная рама',
              'Настройка заднего упора',
              'Система безопасности'
            ],
            applications: [
              'Силовые элементы',
              'Промышленные панели',
              'Крупные изделия'
            ]
          }
        ]
      },
      {
        id: 'anticorrosion-equipment',
        title: 'Оборудование для антикоррозийного покрытия',
        items: [
          {
            name: 'Установка гальванического цинкования',
            description: 'Линия гальванического цинкования для защиты от коррозии.',
            specs: [
              { name: 'Тип покрытия', value: 'Гальваническое цинкование' },
              { name: 'Применение', value: 'Антикоррозионная защита' },
              { name: 'Отделка', value: 'Равномерное покрытие' }
            ],
            capabilities: [
              'Равномерная толщина слоя',
              'Защита от коррозии в агрессивных средах'
            ],
            media: [
              '/img/new_equipment/galvonic_zink/IMG_1360.JPG'
            ],
            features: [
              'Подготовка поверхности (обезжиривание/травление)',
              'Контроль параметров электролита',
              'Промывки и сушка'
            ],
            applications: [
              'Метизная продукция',
              'Листовые и фасонные детали',
              'Серийные партии'
            ]
          },
          {
            name: 'Оборудование для термодиффузионного цинкования',
            description: 'Создание цинкового покрытия методом термодиффузии.',
            specs: [
              { name: 'Тип покрытия', value: 'Термодиффузионное цинкование' },
              { name: 'Толщина покрытия', value: '15-120 мкм' }
            ],
            capabilities: [
              'Высокая адгезия покрытия',
              'Повышенная коррозионная стойкость',
              'Равномерность слоя на сложной геометрии'
            ],
            features: [
              'Сухой процесс без водных ванн',
              'Глубокое диффузионное сцепление',
              'Подходит для метизов и сложных деталей'
            ],
            applications: [
              'Крепёж',
              'Детали с резьбой',
              'Изделия с полостями и кромками'
            ]
          },
          {
            name: 'Полимерно-порошковая покрасочная камера',
            description: 'Камера для нанесения порошковых покрытий высокого качества.',
            specs: [
              { name: 'Тип покрытия', value: 'Полимерно-порошковое' },
              { name: 'Цветовая гамма', value: 'RAL' },
              { name: 'Отделка', value: 'Износостойкое декоративное покрытие' }
            ],
            capabilities: [
              'Широкая цветовая гамма',
              'Устойчивость к истиранию и коррозии',
              'Экологичность процесса'
            ],
            features: [
              'Система рекуперации порошка',
              'Фильтрация и вентиляция',
              'Совместимость с печью полимеризации'
            ],
            applications: [
              'Корпуса и панели',
              'Ограждения и мебель',
              'Серийные окраски'
            ],
            media: [
              '/img/new_equipment/polimerno_poroskovaya_kamera/Полимерно_порошковая_покрасочная_камера-2.jpeg'
            ]
          }
        ]
      },
      {
        id: 'surface-treatment',
        title: 'Оборудование для подготовки поверхности',
        items: [
          {
            name: 'Дробеметный барабан',
            description: 'Дробемётная очистка навалочных мелко- и среднегабаритных деталей.',
            specs: [
              { name: 'Назначение', value: 'Подготовка поверхности перед покрытием' },
              { name: 'Процесс', value: 'Дробемётная очистка (барабанное исполнение)' },
              { name: 'Абразив', value: 'Колотая/литая дробь (по задаче)' }
            ],
            capabilities: [
              'Удаление окалины и ржавчины',
              'Создание равномерной шероховатости',
              'Улучшение адгезии покрытий'
            ],
            features: [
              'Непрерывный цикл загрузка-очистка-выгрузка',
              'Пылеулавливание и рециркуляция абразива',
              'Регулировка расхода дроби'
            ],
            applications: [
              'Крепёж, штамповки',
              'Литые мелкие детали',
              'Предподготовка под цинк/порошок'
            ],
            media: [
              '/img/new_equipment/drobemetnyi_baraban/IMG_1359-2.JPG'
            ]
          },
          {
            name: 'Дробемет подвесного типа',
            description: 'Очистка крупногабаритных/сложнопрофильных изделий на крюках/конвейере.',
            specs: [
              { name: 'Назначение', value: 'Подготовка поверхности' },
              { name: 'Процесс', value: 'Дробемётная очистка (подвесное исполнение)' },
              { name: 'Система подвески', value: 'Крюки/моно- или двухрельсовый конвейер' }
            ],
            capabilities: [
              'Обработка тяжелых и нестандартных деталей',
              'Снятие окалины, ржавчины и старых покрытий',
              'Формирование равномерной шероховатости'
            ],
            features: [
              'Программируемые циклы обработки',
              'Система регенерации абразива',
              'Пылеулавливающий фильтр'
            ],
            applications: [
              'Рамы, корпуса, сварные узлы',
              'Литые и кузнечные заготовки',
              'Крупные панели/профили'
            ],
            media: [
              '/img/new_equipment/drobemet_podvesnogo_tipa/IMG_1330-2.jpg',
              '/img/new_equipment/drobemet_podvesnogo_tipa/IMG_1331-2.jpg'
            ]
          },
          {
            name: 'Зиговочная машина',
            description: 'Профилирование кромок и придание жёсткости листовому металлу.',
            specs: [
              { name: 'Назначение', value: 'Усиление жёсткости листов' },
              { name: 'Применение', value: 'Создание соединительных элементов, формирование ребер жёсткости' }
            ],
            capabilities: [
              'Профилирование по кромке',
              'Формирование зигов/фальцев',
              'Подготовка к соединению панелей'
            ],
            features: [
              'Набор роликов под различные профили',
              'Регулировка прижима и глубины',
              'Стабильная геометрия кромок'
            ],
            applications: [
              'Воздуховоды и кожухи',
              'Короба и панели',
              'Элементы отделки'
            ],
            media: [
              '/img/new_equipment/zigovochnaua_mashina/IMG_1340-2-2.jpg'
            ]
          }
        ]
      },
      {
        id: 'forming-equipment',
        title: 'Трубогибочное оборудование',
        items: [
          {
            name: 'GS90 (полуавтоматический трубогиб)',
            description: 'Полуавтоматический трубогиб для диаметров до 90 мм.',
            specs: [
              { name: 'Макс. диаметр гибки', value: '90 мм' },
              { name: 'Материалы', value: 'Сталь, алюминий, медь' },
              { name: 'Тип', value: 'Полуавтоматический' }
            ],
            capabilities: [
              'Точное соблюдение радиусов',
              'Гибка без видимой деформации (при правильной оснастке)',
              'Различные углы гибки'
            ],
            features: [
              'Сменные дорны и прижимы',
              'Настройка скорости/угла',
              'Поддержка шаблонов (NC/упоры — по комплектации)'
            ],
            applications: [
              'Поручни и ограждения',
              'Рамы и каркасы',
              'Системы трубопроводов'
            ],
            videos: [
              { type: 'local', url: '/img/new_equipment/GS90/IMG_1361.MP4', title: 'GS90 трубогиб в работе' }
            ]
          }
        ]
      }
    ],
    products: [
      {
        id: 'auto-components',
        title: 'Автомобильные компоненты',
        description: 'Производство высококачественных автомобильных компонентов из металла.',
        image: '/img/ac.png'
      },
      {
        id: 'mounting-units',
        title: 'Монтажные узлы',
        description: 'Изготовление монтажных узлов для различных конструкций и оборудования.',
        image: '/img/my.jpg'
      },
      {
        id: 'facade-panels',
        title: 'Фасадные панели',
        description: 'Производство металлических фасадных панелей для отделки зданий.',
        image: '/img/fc.jpg'
      },
      {
        id: 'metal-beds',
        title: 'Грядки из металла',
        description: 'Изготовление долговечных металлических грядок для садоводства.',
        image: '/img/gr.webp'
      }
    ],
    // Состояние модального окна оборудования
    equipmentModal: {
      show: false,
      machine: null,
      image: ''
    }
  },
  getters: {
    getServiceById: (state) => (id) => {
      return state.services.find(service => service.id === id)
    },
    getEquipmentById: (state) => (id) => {
      return state.equipment.find(equipment => equipment.id === id)
    },
    getProductById: (state) => (id) => {
      return state.products.find(product => product.id === id)
    }
  },
  mutations: {
    openEquipmentModal(state, { machine, image }) {
      state.equipmentModal.show = true
      state.equipmentModal.machine = machine
      state.equipmentModal.image = image
    },
    closeEquipmentModal(state) {
      state.equipmentModal.show = false
      state.equipmentModal.machine = null
      state.equipmentModal.image = ''
    }
  },
  actions: {
  },
  modules: {
  }
})
